import { render, staticRenderFns } from "./outbound-tour.vue?vue&type=template&id=6b23739b&scoped=true"
import script from "./outbound-tour.vue?vue&type=script&lang=js"
export * from "./outbound-tour.vue?vue&type=script&lang=js"
import style0 from "./outbound-tour.vue?vue&type=style&index=0&id=6b23739b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b23739b",
  null
  
)

export default component.exports